import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SidebarItem } from '../screens';
import { useParams } from 'react-router-dom';
import { useUser } from '../hooks';
import UserAccess from '../UserAccess';

interface EventSidebarProps{
	
}

var EventSidebar = (props: EventSidebarProps)=>{
	var params = useParams<{ id: string }>();
	var { t } = useTranslation();
	var { hasAccess } = useUser();
	
	return <>
		<SidebarItem iconName='arrow-left' text='Regresar' goBack />
		<div className='divider'>Evento</div>
		{hasAccess(UserAccess.EVENTS.VIEW_COMMENTS) && (
			<SidebarItem iconName='comments' text='Comentarios' to={`/events/${params.id}/comments`} />
		)}
		{hasAccess(UserAccess.EVENTS.VIEW_EVENT_WORKERS) && (
			<SidebarItem iconName='user-gear' text='Trabajadores' to={`/events/${params.id}/workers`} />
		)}
		{hasAccess(UserAccess.EVENTS.VIEW_EXPENSE) && (
			<SidebarItem iconName='money-bill-wave' text='Gastos' to={`/events/${params.id}/expenses`} />
		)}
		<SidebarItem iconName='file-image' text='Evidencias' to={`/events/${params.id}/assets`} />
		{hasAccess(UserAccess.EVENTS.VIEW_EVENT_FORM) && (
			<SidebarItem iconName='clipboard-list' text='Formulario' to={`/events/${params.id}/form`} />
		)}
	</>
}

export default EventSidebar;